import fetch from './fetch'

class BillApi {
	public addBill(form: any) {
		return fetch({
			url: 'injury/order/v140/addInvoice',
			method: 'post',
			data: form,
		})
	}

	public addBosssoftBill(form: any) {
		return fetch({
			url: '/injury/bosssoft/invoice/add',
			method: 'post',
			data: form,
		})
	}

	public getBosssoftDetail(orderId: any) {
		return fetch({
			url: '/injury/bosssoft/invoice/detail',
			params: {
				orderId,
			},
		})
	}

	public editBosssoftTask(form: any) {
		return fetch({
			url: '/injury/bosssoft/invoice/edit',
			method: 'post',
			data: form,
		})
	}

	public exportBosssoftTask(orderId: string) {
		return fetch({
			url: '/injury/bosssoft/invoice/export',
			method: 'GET',
			params: {
				orderId,
			},
			timeout: 0,
			responseType: 'blob',
		})
	}

	public importBosssoftTask(form: any) {
		return fetch({
			url: '/injury/bosssoft/invoice/import',
			method: 'post',
			data: form,
		})
	}

	public getList(form: any) {
		return fetch({
			url: 'injury/tasklist/v140/invoiceList',
			method: 'post',
			data: form,
		})
	}

	public getDetail(orderId: any) {
		return fetch({
			url: 'injury/order/v140/invoiceDetail',
			params: {
				orderId,
			},
		})
	}

	public getMedicalRecordDetail(orderId: any) {
		return fetch({
			url: 'injury/order/invoice/medicalRecordDetail',
			params: {
				orderId,
			},
		})
	}

	public invoiceSearchResult(orderId: any) {
		return fetch({
			url: 'injury/order/v140/invoiceSearchResult',
			params: {
				orderId,
			},
		})
	}

	public researchInvoice(orderId: any) {
		return fetch({
			url: 'injury/order/v140/researchInvoice',
			params: {
				orderId,
			},
		})
	}

	public checkInvoice(form: any) {
		return fetch({
			url: 'injury/order/v140/checkInvoice',
			method: 'post',
			data: form,
		})
	}

	public parseInvoice(form: any) {
		return fetch({
			url: 'injury/order/v140/parseInvoice',
			method: 'post',
			data: form,
			// timeout: 0,
		})
	}

	public medicalOrg(data: any) {
		return fetch({
			url: 'injury/order/invoice/medicalOrg',
			method: 'get',
			params: data,
		})
	}

	public invoiceProvince(keyword: string) {
		return fetch({
			url: 'injury/order/invoice/province',
			method: 'get',
			params: {
				keyword,
			},
		})
	}

	public queryMedicalRecord(form: any) {
		return fetch({
			url: 'injury/order/invoice/queryMedicalRecord',
			method: 'POST',
			data: form,
		})
	}

	public exportOrder(orderId: string) {
		return fetch({
			url: 'injury/order/invoice/export',
			method: 'GET',
			params: {
				orderId,
			},
			timeout: 0,
			responseType: 'blob',
		})
	}
}

export default new BillApi()
